<template>
	<div class="d-flex justify-start align-center">
		<v-file-input
			hide-input
			style="display: none"
			:multiple="multiple"
			:accept="accept"
			@change="uploadByVuetifyFileInput"
		></v-file-input>
		<input
			type="file"
			ref="fileInput"
			:multiple="multiple"
			:accept="accept"
			style="display: none"
			@change="uploadByNativeFileInput"
		/>

		<slot v-bind="{ trigger, progress }">
			<!--
          <v-btn
              color="primary"
              @click="$refs.fileInput.click()"
              class="d-flex flex-column align-center justify-center"
          >
              <div><v-icon>mdi-plus</v-icon></div>
              <div>Upload</div>
          </v-btn>-->
			<v-btn color="primary" @click="trigger">Upload File</v-btn>
			<v-progress-linear v-model="progress" color="blue" height="10"></v-progress-linear>
		</slot>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'UploaderNew',
	props: {
		multiple: { type: Boolean, default: false },
		preview: { type: Boolean, default: false },
		accept: { type: String, default: '*/*' },
		config: { type: String, default: 'default' }
	},
	data() {
		return {
			upconfig: {},
			files: [],
			progress: 0,
			tries: {}, //filename:times
			retryLimit: 2,
			total: 0
		}
	},
	mounted() {
		this.loadConfig()
	},
	methods: {
		trigger(event) {
			this.$refs.fileInput.click()
		},
		loadConfig() {
			this.$http
				.get('/common/upconfig/' + this.config, {})
				.then((response) => {
					this.upconfig = response
				})
				.catch((error) => {
					console.log(error)
				})
		},
		validateFileSize(files, each = 2) {
			const maxSize = each * 1024 * 1024 // 2MB
			for (let i = 0; i < files.length; i++) {
				if (files[i].size > maxSize) {
					return false
				}
			}
			return true
		},
		resizeImage(file, maxSize) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = (e) => {
					const img = new Image()
					img.onload = () => {
						let canvas = document.createElement('canvas')
						let ctx = canvas.getContext('2d')
						let width = img.width
						let height = img.height
						let resizeRatio = 1

						// Adjust resizeRatio to reduce file size under maxSize
						while (file.size > maxSize && resizeRatio > 0.1) {
							resizeRatio -= 0.1
							width = img.width * resizeRatio
							height = img.height * resizeRatio
							canvas.width = width
							canvas.height = height
							ctx.clearRect(0, 0, width, height)
							ctx.drawImage(img, 0, 0, width, height)

							canvas.toBlob(
								(blob) => {
									if (!blob) return
									console.log('compressed', blob, maxSize)
									if (blob.size <= maxSize) {
										resolve(blob)
									}
								},
								file.type,
								0.7
							) // Adjust quality to further control size
						}
					}
					img.src = e.target.result
				}
				reader.onerror = (error) => reject(error)
				reader.readAsDataURL(file)
			})
		},
		async uploadByNativeFileInput(event) {
			let files = event.target.files
			if (!this.validateFileSize(files)) {
				// alert('文件大小不能超过2MB')
				// return
				alert('文件尺寸超过2MB，进行自动缩减以便浏览')
				files = await this.resizeImage(files[0], 2 * 1024 * 1024)
			}

			if (this.multiple) {
				for (var i = 0; i < files.length; i++) {
					let formData = new FormData()
					formData.append('file', files[i])
					this.upload(formData, files[i])
				}
				this.total = files.length
			} else {
				this.total = 1
				let formData = new FormData()
				formData.append('file', files[0])
				this.upload(formData, files[0])
			}
		},
		uploadByVuetifyFileInput(files) {
			if (!this.validateFileSize(files)) {
				alert('File size should be less than 2MB')
				return
			}

			if (this.multiple) {
				for (var i = 0; i < files.length; i++) {
					let formData = new FormData()
					formData.append('file', files[i])
					this.upload(formData, files[i])
				}
			} else {
				let formData = new FormData()
				formData.append('file', files)
				this.upload(formData, files)
			}
		},
		hasFormDataKey(formData, key) {
			for (let pair of formData.entries()) {
				if (pair[0] === key) return true
			}
			return false
		},
		upload(formData, file) {
			if (!this.hasFormDataKey(formData, 'policy')) {
				//由于在失败重试时会再次调用 - 避免重复添加
				formData.append('policy', this.upconfig['policy'])
			}
			if (!this.hasFormDataKey(formData, 'signature')) {
				formData.append('signature', this.upconfig['signature'])
			}

			var self = this
			var url = 'https://v0.api.upyun.com/' + this.upconfig.bucket + '/'
			axios
				.post(url, formData, {
					method: 'post',
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					transformRequest: [
						function (data) {
							return data
						}
					],
					onUploadProgress: function (e) {
						var percentage = Math.round((e.loaded * 100) / e.total) || 0
						if (percentage <= 100) {
							self.progress = percentage
							console.log(percentage + '%') // 上传进度
						}
					}
				})
				.then((resp) => {
					var imgurl = self.upconfig.cdn + resp.data.url
					console.log('uploaded', this.total, imgurl)
					self.files.push(imgurl)
					self.onUploaded([imgurl])
					this.total--
					if (this.total === 0) {
						this.$refs.fileInput.value = null
						this.onUploadedAll()
					} else {
						self.loadConfig() //可能会再次上传
					}
				})
				.catch((e) => {
					console.log('upload failed', e)
					if (!this.tries[file.name]) this.tries[file.name] = 1
					if (this.tries[file.name] < this.retryLimit) {
						this.loadConfig()
						this.tries[file.name]++
						this.upload(formData, file)
					} else {
						alert('上传失败，请重试')
						this.onUploadFail()
					}
				})
		},
		onUploadFail() {
			this.$refs.fileInput.value = null
		},
		onUploaded(file) {
			this.$refs.fileInput.value = null
			console.log('uploaded', file)
			this.$emit('uploaded', file)
		},
		onUploadedAll() {
			console.log('uploaded all')
			this.$emit('uploadedAll', this.files)
		}
	}
}
</script>

<style scoped></style>
